"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFormBridge = void 0;
/* eslint-disable no-param-reassign */
const react_1 = require("react");
const rxjs_1 = require("rxjs");
const form_1 = require("../types/form");
const useBuyForm_1 = require("./useBuyForm");
function useFormBridge({ validator_, values_ }, { setCurrentValues }, { checkOrder, customValidator }) {
    const [errors, setErrors] = (0, react_1.useState)({});
    const { status: formStatus, dispatch: dispatchFormAction, status$: formStatus$, validate, submit, } = (0, useBuyForm_1.useBuyForm)();
    const customValidatorRef = (0, react_1.useRef)();
    (0, react_1.useEffect)(() => {
        customValidatorRef.current = customValidator;
    }, [customValidator]);
    const onChange = (0, react_1.useCallback)((paramKey, newValue) => {
        setCurrentValues(prev => {
            prev[paramKey] = newValue;
        });
        dispatchFormAction(form_1.FormAction.EDIT);
    }, [dispatchFormAction, setCurrentValues]);
    // 绑定验证操作
    const validatorRef = (0, react_1.useRef)();
    (0, react_1.useEffect)(() => {
        const validateSub = formStatus$
            .pipe((0, rxjs_1.filter)(status => status === form_1.FormStatus.VALIDATING), (0, rxjs_1.withLatestFrom)(values_, validator_), (0, rxjs_1.tap)(([, , validator]) => {
            // 同步一下最新的validator
            validatorRef.current = validator;
        }), (0, rxjs_1.map)(([, current, validator]) => {
            const result = validator.validate(current);
            let customResult = undefined;
            if (customValidatorRef === null || customValidatorRef === void 0 ? void 0 : customValidatorRef.current) {
                customResult = customValidatorRef.current(current);
            }
            return Promise.resolve(customResult).then(customResult => {
                if (customResult) {
                    return mergeValidateResult(result, customResult);
                }
                return result;
            });
        }))
            .subscribe({
            next: (resultPromise) => __awaiter(this, void 0, void 0, function* () {
                const result = yield resultPromise;
                const hasError = !!Object.keys(result).length;
                setErrors(result);
                if (hasError) {
                    dispatchFormAction(form_1.FormAction.FAIL);
                }
                else {
                    dispatchFormAction(form_1.FormAction.SUCCESS);
                }
            }),
        });
        const clearErrorSub = formStatus$
            .pipe((0, rxjs_1.filter)(status => status === form_1.FormStatus.DIRTY), (0, rxjs_1.distinctUntilChanged)())
            .subscribe({
            next: () => {
                setErrors({});
            },
        });
        return () => {
            validateSub.unsubscribe();
            clearErrorSub.unsubscribe();
        };
    }, [dispatchFormAction, formStatus$, validator_, values_]);
    const validateFieldBuilder = (0, react_1.useCallback)((fieldName, current) => (value) => { var _a; return (_a = validatorRef.current) === null || _a === void 0 ? void 0 : _a.validate(current, fieldName, value); }, []);
    const checkOrderFuncRef = (0, react_1.useRef)();
    (0, react_1.useEffect)(() => {
        if (checkOrder === null || checkOrder === void 0 ? void 0 : checkOrder.checkOrder) {
            checkOrderFuncRef.current = checkOrder.checkOrder;
        }
    }, [checkOrder.checkOrder]);
    const lastCheckOrderFuncRetRef = (0, react_1.useRef)();
    // 绑定提交操作
    (0, react_1.useEffect)(() => {
        const submitSub = formStatus$
            .pipe((0, rxjs_1.filter)(status => status === form_1.FormStatus.SUBMITTING), (0, rxjs_1.switchMap)(() => (checkOrderFuncRef.current ? (0, rxjs_1.from)(checkOrderFuncRef.current()) : rxjs_1.EMPTY)), (0, rxjs_1.catchError)((_err, caught) => {
            // 报错了的情况下抛出错误，并重新订阅
            dispatchFormAction(form_1.FormAction.FAIL);
            return caught;
        }))
            .subscribe(checkOrderFuncRet => {
            lastCheckOrderFuncRetRef.current = checkOrderFuncRet;
            dispatchFormAction(form_1.FormAction.SUCCESS);
        });
        return () => {
            submitSub.unsubscribe();
        };
    }, [dispatchFormAction, formStatus$]);
    const handleSubmit = (0, react_1.useCallback)((cb) => __awaiter(this, void 0, void 0, function* () {
        const ret = yield submit();
        if (ret) {
            cb === null || cb === void 0 ? void 0 : cb(lastCheckOrderFuncRetRef.current);
        }
    }), [submit]);
    return {
        errors,
        onChange,
        validateFieldBuilder,
        formStatus,
        validate,
        submit: handleSubmit,
    };
}
exports.useFormBridge = useFormBridge;
/**
 * 合并ValidateResult列表，前面的优先级更高
 * 针对同一个字段，当前面的结果没有报错，才会看后面的是否有报错
 */
function mergeValidateResult(innerResult, customResult) {
    const result = Object.assign({}, innerResult);
    for (const key of Object.keys(customResult)) {
        if (!result[key] && customResult[key]) {
            result[key] = {
                entity: customResult[key],
            };
        }
    }
    return result;
}
